'use client'

import { Builder, withChildren } from '@builder.io/react'

import { TopBanner } from './TopBanner'
import { TopBannerDefaults } from './TopBanner.defaults'

Builder.registerComponent(withChildren(TopBanner), {
  name: 'Top Banner',
  inputs: [
    {
      name: 'textColor',
      type: 'color',
      defaultValue: TopBannerDefaults.textColor,
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: TopBannerDefaults.backgroundColor,
    },
    {
      name: 'isSticky',
      type: 'boolean',
      defaultValue: TopBannerDefaults.isSticky,
    },
    {
      name: 'height',
      type: 'number',
      defaultValue: TopBannerDefaults.height,
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Get 50% Off—JOIN NOW' } },
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/photo.svg',
})
